import AddPillButton from "../../../generic-building-blocks/pills/AddPillButton";
import { getAppend, getRemove, getUpdate } from "../../../generic-building-blocks/pills/utils";
import RowFilterItem from "./RowFilterItem";
import { ClientRowFilter } from "@avenueops/shared-types";
import { DropdownSelect, SmartForm } from "@avenueops/web-components";
import { Relation, ColumnType, FilterMatchType } from "@prisma/client";
import InputToggableText from "components/inputs/InputToggleableText";
import React from "react";
import { useFormContext } from "react-hook-form";
import { Controller } from "react-hook-form";

interface Props {
  queryColumns: string[];
  readOnly?: boolean;
}

export const starterFilter: ClientRowFilter = { relation: Relation.IS, columnType: ColumnType.STRING, value: "", columnName: "" };
const rowFilterMatchOptions = [
  {
    value: FilterMatchType.ALL,
    label: "all filters",
  },
  {
    value: FilterMatchType.ANY,
    label: "any filter",
  },
];
/**
 * The list of row filters displayed in the monitor form
 */
export default function RowFilterList({ queryColumns, readOnly }: Props): JSX.Element {
  const { control, watch } = useFormContext();
  const rowFilters = watch("rowFilters");
  return (
    <div className="flex gap-x-2">
      <div className="flex-1 flex flex-row gap-x-2">
        <Controller
          control={control}
          name="rowFilters"
          render={({ field: { value, onChange } }) => (
            <>
              <div
                key={value.length}
                className={`border rounded-lg border-gray-300 text-gray-600 flex flex-row gap-2 px-3 py-2 h-10 pr-6 items-center justify-center text-center font-normal leading-tight text-sm ${
                  value?.length < 1 ? "bg-white flex-1 hover:bg-gray-100" : "bg-primary-regular text-white"
                }`}
                onClick={!readOnly ? getAppend<ClientRowFilter>(onChange, value, starterFilter) : undefined}
              >
                <svg width="21" height="20" viewBox="0 0 21 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.5 5.75C4.5 5.33579 4.80996 5 5.19231 5H15.8077C16.19 5 16.5 5.33579 16.5 5.75C16.5 6.16421 16.19 6.5 15.8077 6.5H5.19231C4.80996 6.5 4.5 6.16421 4.5 5.75Z"
                  />
                  <path d="M6.5 9.5C6.5 9.08579 6.7982 8.75 7.16606 8.75H13.8339C14.2018 8.75 14.5 9.08579 14.5 9.5C14.5 9.91421 14.2018 10.25 13.8339 10.25H7.16606C6.7982 10.25 6.5 9.91421 6.5 9.5Z" />
                  <path d="M7.5 13.25C7.5 12.8358 7.83235 12.5 8.24232 12.5H12.7577C13.1677 12.5 13.5 12.8358 13.5 13.25C13.5 13.6642 13.1677 14 12.7577 14H8.24232C7.83235 14 7.5 13.6642 7.5 13.25Z" />
                </svg>
                {value.length > 0 ? `Filter (${value.length})` : "Filter"}
              </div>
              {value.length > 0 ? (
                <div className="flex-1 flex flex-wrap gap-y-2 gap-x-1">
                  {value.map((rowFilter: any, index: any) => (
                    <div key={index}>
                      <RowFilterItem
                        index={index}
                        columns={queryColumns}
                        rowFilter={rowFilter}
                        onDelete={!readOnly ? getRemove<ClientRowFilter>(onChange, index, value) : () => {}}
                        onChange={!readOnly ? getUpdate<ClientRowFilter>(onChange, index, value) : () => {}}
                      />
                    </div>
                  ))}
                </div>
              ) : null}
            </>
          )}
        />
      </div>
      {rowFilters.length > 1 ? (
        <div className="w-29">
          <SmartForm.DropdownSelect
            type="BUTTON"
            name="rowFilterMatchType"
            options={[
              {
                value: FilterMatchType.ALL,
                label: "and",
              },
              {
                value: FilterMatchType.ANY,
                label: "or",
              },
            ]}
            placeholder=""
            disabled={readOnly}
          />
        </div>
      ) : null}
    </div>
  );
}
